<template>
	<div
		@click="router.replace(routeLink)"
		class="flex flex-col lg:p-6 p-4 space-y-2 border border-gray-200 cursor-pointer rounded-2xl">
		<div class="flex items-center justify-between w-full">
			<p class="p-2 font-bold text-xs rounded-[6px] bg-primary-400 text-primary-600 leading-[18px]">
				{{ caseNumber || "Offline(No Case Number)" }}
			</p>
			<div class="flex items-center space-x-2">
				<date-detail :date="date" />
				<div @click.stop>
					<delete-button @click="showDeleteModal(caseNumber)" class="shrink-0" />
				</div>
			</div>
		</div>
		<div>
			<p class="text-neutral-500 text-[0.625rem]">Primary Diagnosis</p>
			<p class="mt-1 text-sm font-bold">{{ primaryDiagnosis }}</p>
		</div>
		<div>
			<p class="text-neutral-500 text-[0.625rem]">Comorbid</p>
			<div class="flex flex-wrap items-center">
				<template v-for="list in comorbidList" :key="list">
					<span
						v-if="list"
						class="px-2 py-1 mt-1 mr-1 text-xs italic bg-neutral-200 text-neutral-600 rounded-2xl">
						{{ list }}
					</span>
				</template>
			</div>
		</div>
		<div>
			<p class="text-neutral-500 text-[0.625rem]">Perpetrator</p>
			<div class="flex flex-wrap items-center">
				<span
					v-for="list in perpetratorList"
					:key="list"
					class="px-2 py-1 mt-1 mr-1 text-xs italic bg-neutral-200 text-neutral-600 rounded-2xl">
					{{ list }}
				</span>
			</div>
		</div>
	</div>
	<confirmation-modal
		:typeTwo="true"
		:show="showConfirmation"
		@cancel="showConfirmation = false"
		@confirm="deleteRecord()"
		cancel-text="Cancel"
		action-text="Confirm"
		title="Delete Record"
		content="Are you sure you wish to delete this Case?" />
	<success-modal
		:show="showSuccess"
		@confirm="showSuccess = false"
		action-text="Close"
		title="Record Deleted!"
		content="Selected Case has been successfully deleted!" />
</template>
<script setup lang="ts">
import { PropType, ref } from "vue";
import DateDetail from "@/components/partials/DateDetail.vue";
import { useRouter } from "vue-router";
import DeleteButton from "@/components/buttons/DeleteButton.vue";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import http from "@/axios";

const router = useRouter();
const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const selectedId = ref(null);
const props = defineProps({
	routeLink: {
		type: String,
		default: "#",
	},
	routeDeleteLink: {
		type: String,
		default: "#",
	},
	caseNumber: {
		type: String,
		default: null,
	},
	primaryDiagnosis: {
		type: String,
		default: null,
	},
	comorbidList: {
		type: Array as PropType<string[]>,
		default: () => [],
	},
	perpetratorList: {
		type: Array as PropType<string[]>,
		default: () => [],
	},
	date: {
		type: String,
		default: null,
	},
});

const showDeleteModal = (item: any): void => {
	showConfirmation.value = true;
	selectedId.value = item;
};

const deleteRecord = async () => {
	await http
		.delete(props.routeDeleteLink)
		.then(() => {
			showSuccess.value = true;
			showConfirmation.value = false;
			window.location.reload();
		})
		.catch((error) => console.log(error));
};
</script>
